/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const skillAssignmentSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  organizationId: z.string(),
  resourceId: z.int(),
  skillId: z.int(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
